import ACTIONS from "../Design_Asset_Actions.json";

const initialCount = {
  derCount: 0,
  loadCount: 0,
  evCount: 0,
  remoteLoadCount: 0,
  gTCount:0,
};

const countReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_DER_COUNT:
      return {
        ...state,
        derCount: state.derCount + action.payload.count,
      };
    case ACTIONS.UPDATE_LOAD_COUNT:
      return {
        ...state,
        loadCount: state.loadCount + action.payload.count,
      };
    case ACTIONS.UPDATE_LOAD_COUNT_ONLY_ONE:
      return {
        ...state,
        loadCount:  action.payload.count,
      };
    case ACTIONS.UPDATE_EV_COUNT:
      return {
        ...state,
        evCount: state.evCount + action.payload.count,
      };
    case ACTIONS.UPDATE_GT_COUNT:
      return {
        ...state,
        gTCount: state.gTCount + action.payload.count,
      };
    case ACTIONS.RESET_EV_COUNT:
      return {
        ...state,
        evCount: action.payload.count,
      };
    case ACTIONS.UPDATE_REMOTE_LOAD_COUNT:
      return {
        ...state,
        remoteLoadCount: state.remoteLoadCount + action.payload.count,
      };
    case ACTIONS.RESET_SLD_COUNT:
      return {
        derCount: 0,
        loadCount: 0,
        evCount: 0,
        remoteLoadCount: 0,
      };
    default:
      return state;
  }
};

export { initialCount, countReducer };
